import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react';
import getRootModule from 'RootModule';
import getSalesGoalsMassiveUploadModule from '../getSalesGoalsMassiveUploadModule';
import { layoutContext } from 'context';
import { useHistory } from 'react-router-dom';
import { Form } from 'antd';
import {
  MassiveUploadTable,
  UploadExcelButton,
  ActionButtonsExcelUpload,
} from 'common/MassiveUploads/components';
import { triggerModalForDuplicates } from 'common/MassiveUploads/utils';
//cambiar sagas
import {
  salesGoalsMassiveUploadSetAllowUpload,
  salesGoalsMassiveUploadRequestVerify,
  salesGoalsMassiveUploadRequestUpload,
  salesGoalsMassiveUploadClearUpload,
  salesGoalsMassiveUploadClearVerify,
  salesGoalsMassiveUploadClearAllowUpload,
} from '../redux-saga/actions';
import tableColumns from '../schemas/massiveUploadTableColumns'; //cambiar columna

const SalesGoalsMassiveUpload = (props) => {
  const {
    salesGoalsMassiveUploadSetAllowUpload: setAllowUpload,
    salesGoalsMassiveUploadRequestVerify: requestVerify,
    salesGoalsMassiveUploadRequestUpload: requestUpload,
    salesGoalsMassiveUploadClearUpload: clearUpload,
    salesGoalsMassiveUploadClearVerify: clearVerify,
    salesGoalsMassiveUploadClearAllowUpload: clearAllowUpload,
    allowUpload,
    verify,
  } = props;

  const history = useHistory();
  const [form] = Form.useForm();
  const { onChangeActiveComponent } = useContext(layoutContext);
  const [fileString, setFileString] = useState('');

  const correct = verify?.correct;
  const entriesList = verify?.objectList;
  const totalDuplicatedEntries = verify?.replaced?.length;
  const allCorrectMessage = verify?.allCorrectMessage;

  useEffect(() => {
    clearAllowUpload();
    return () => {
      clearAllowUpload();
      clearUpload();
      clearVerify();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (correct > 0) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
    onChangeActiveComponent('activo');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correct]);

  function customRequest({ file }) {
    onChangeActiveComponent('BusinessStructureMassiveUpload');
    requestVerify({ file, setFileString });
  }

  function requestReplace() {
    requestUpload({ history, fileString, overwrite: true });
  }
  function requestKeep() {
    requestUpload({ history, fileString, overwrite: false });
  }
  function onSubmit() {
    if (totalDuplicatedEntries > 0) {
      triggerModalForDuplicates(
        totalDuplicatedEntries,
        requestReplace,
        requestKeep,
        'metas de venta'
      );
      return;
    }
    requestReplace();
  }
  function onCancel() {
    history.push(`/catalog`);
  }

  return (
    <Form form={form}>
      <UploadExcelButton customRequest={customRequest} />
      <MassiveUploadTable
        data={entriesList}
        columns={tableColumns}
        allCorrectMessage={allCorrectMessage}
      />
      <ActionButtonsExcelUpload
        onSubmit={onSubmit}
        onCancel={onCancel}
        disabled={!allowUpload}
        buttons={['cancel', 'submit']}
      />
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    allowUpload: state?.SALESGOALS_MASSIVE_UPLOAD?.allowUpload,
    verify: state?.SALESGOALS_MASSIVE_UPLOAD?.verify,
  };
};

const ConnectedSalesGoalsMassiveUpload = connect(mapStateToProps, {
  salesGoalsMassiveUploadSetAllowUpload,
  salesGoalsMassiveUploadRequestVerify,
  salesGoalsMassiveUploadRequestUpload,
  salesGoalsMassiveUploadClearUpload,
  salesGoalsMassiveUploadClearVerify,
  salesGoalsMassiveUploadClearAllowUpload,
})(SalesGoalsMassiveUpload);

const SalesGoalsMassiveUploadWithModules = () => {
  return (
    <DynamicModuleLoader modules={[getRootModule(), getSalesGoalsMassiveUploadModule()]}>
      <ConnectedSalesGoalsMassiveUpload />
    </DynamicModuleLoader>
  );
};
export default SalesGoalsMassiveUploadWithModules;
